// src/component/Profile/FamilyMember/BloodGroupDropdown.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

export default function BloodGroupDropdown({ value, onChange }) {
  const [bloodGroups, setBloodGroups] = useState([]);

  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const MASTER_API = `${BASE_API_URL}MasterAPI`;

  useEffect(() => {
    const fetchBloodGroups = async () => {
      try {
        const res = await axios.get(`${MASTER_API}/GetBloodGroups`);
        setBloodGroups(res.data || []);
      } catch (error) {
        console.error("GetBloodGroups API Error:", error);
        toast.error("Failed to fetch blood groups");
      }
    };

    fetchBloodGroups();
  }, []);

  return (
    <select
      name="bloodGroup"
      className="form-select"
      value={value}
      onChange={onChange}
    >
      <option value="">Select Blood Group</option>
      {bloodGroups.map((bg) => (
        <option key={bg.id} value={bg.name}>
          {bg.name}
        </option>
      ))}
    </select>
  );
}
